<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col class="text-center col-10 col-sm-8 col-md-6 col-lg-4 col-xl-3">
        <p class="title primary--text">Password Reset Request</p>
        <div class="grey lighten-5">
          <div class="pa-5">
            <AAlert :alert="alert"></AAlert>
            <v-form @submit.prevent="submit" ref="form" lazy-validation>
              <v-text-field
                outlined
                v-model="username"
                label="Username"
                :rules="usernameRules"
                :disabled="loading"
              ></v-text-field>
              <v-btn
                depressed
                type="submit"
                color="blue"
                class="white--text"
                :loading="loading"
                :disabled="loading || disabled"
              >Send A Reset Link</v-btn>
            </v-form>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { setTimeout } from "timers";
import snackbar from "../mixins/snackbar";
import AAlert from "../components/AAlert";
import authApi from "../api/auth";
import axios from "../api/axios";

export default {
  name: "recovery",
  mixins: [snackbar],
  components: {
    AAlert
  },
  data: () => ({
    valid: true,
    username: "",
    usernameRules: [
      v => !!v || "Field is required",
      v => (v && v.length > 4) || "Must be atleast 5 characters"
    ],
    loading: false,
    disabled: false,
    alert: {}
  }),
  mounted() {
    this.loading = true;
    authApi.status(data => {
      if (data.ok) {
        if (data.d.signedIn) {
          this.$store.commit("user/set", data.d.user);
          this.$router.push("/");
        }
      }
      this.loading = false;
    });
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.alertType = "success";
        axios
          .post("/auth/send-pwd-reset-token", {
            username: this.username
          })
          .then(r => {
            this.alert = r.data;
            if (r.data.ok) this.disabled = true;
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      }
    }
  },
  computed: {}
};
</script>
